import {
	useQuery,
	type UseQueryOptions,
	type UseQueryResult,
} from '@tanstack/react-query';
import { SERVER_ROUTES } from '../../../shared/constants/routes.constants';
import { generatePath } from '../../../shared/services/app.shared-service';
import type { ErrorResponse } from '../../../shared/types/error';
import { type ConfigResponseSchemaType } from './../../../shared/schemas/configSchemas/configResponses.schema';
import { type ConfigEntity } from './../../../shared/types/config.entity';
import { axiosClient } from './api';

const CONFIG_QUERY_KEY = 'config';
const baseUrl = [SERVER_ROUTES.CONFIG.version, SERVER_ROUTES.CONFIG.BASE];

async function fetchConfig(): Promise<ConfigEntity> {
	const response = await axiosClient.get<ConfigResponseSchemaType>(
		generatePath({
			route: [...baseUrl, SERVER_ROUTES.CONFIG.ROUTES.BASE],
		})
	);
	return response.data.config;
}

/**
 * Custom hook to fetch app config.
 */
export function useConfig(
	options?: UseQueryOptions<ConfigEntity, ErrorResponse>
): UseQueryResult<ConfigEntity, ErrorResponse> {
	return useQuery<ConfigEntity, ErrorResponse>({
		queryKey: [CONFIG_QUERY_KEY],
		queryFn: fetchConfig,
		...options,
	});
}
